import { Link } from 'gatsby';
import styled from 'styled-components';

/**
 * Stled link component
 */
export default styled(Link)`
  color: inherit;
  text-decoration: underline;
  :hover {
    color: inherit;
  }
`;
